class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(document.querySelector('header').getBoundingClientRect().bottom)}px`
    );

    if (triggeredBy) this.setActiveElement(triggeredBy);

    const headerDrawer = document.querySelector('header-drawer');
    if (headerDrawer) {
      const detailsElement = headerDrawer.querySelector('details[open]');
      if (detailsElement) {
        const summaryElement = detailsElement.querySelector('summary');
        headerDrawer.closeMenuDrawer(new Event('close'), summaryElement);

        summaryElement.setAttribute('aria-expanded', 'false');
        detailsElement.classList.remove('menu-opening');
      }
    }

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      console.log("section", section);
      
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      
      console.log("test", Boolean(section.id === "cart-drawer" && (this.hasAttribute('data-empty') === parsedState.sections[section.id].includes('data-empty'))));
      
      if(section.id === "cart-drawer" && (this.hasAttribute('data-empty') === parsedState.sections[section.id].includes('data-empty'))){
        this.updateElementsWithMerge(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector))
      }
      else{
        // this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
        console.log("sectionElement", sectionElement);
        
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }

      if(section.id === "cart-drawer") this.toggleAttribute('data-empty', parsedState.sections[section.id].includes('data-empty'))
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  updateElementsWithMerge(fetchedHTML) {
    const parser = new DOMParser();
    const fetchedDoc = parser.parseFromString(fetchedHTML, 'text/html');
    const fetchedElements = fetchedDoc.querySelectorAll('[data-merge]');

    fetchedElements.forEach(fetchedEl => {
      const mergeType = fetchedEl.getAttribute('data-merge');
      const selector = this.getMatchSelector(fetchedEl);

      if (!selector) return;

      const existingEl = this.querySelector(selector);
      if (!existingEl) return;

      if (mergeType === 'attributes') {
        for (const attr of fetchedEl.attributes) {
          if (attr.name !== 'data-merge') {
            existingEl.setAttribute(attr.name, attr.value);
          }
        }
      } else if (mergeType === 'node') {
        existingEl.replaceWith(fetchedEl);
      }
    });
  }

  getMatchSelector(el) {
    if (el.id) return `#${el.id}`;
    if (el.hasAttribute('data-id')) return `[data-id="${el.getAttribute('data-id')}"]`;
    if (el.classList.length > 0) return `.${[...el.classList].join('.')}`;
    return null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
